export const concatRoutes = (routes: string[]): string => routes.join('');
